export default {
  sections: {
    alcohol_percentage: 'Contenuto alcolico: {{value}}%',
    price_per_unit: 'Prezzo per {{unit}}: {{value}}',
    gtin: 'GTIN',
    ingredients: 'Ingredienti',
    allergens: 'Allergeni',
    additives: 'Additivi',
    nutrition_breakdown: {
      title: 'Informazioni nutrizionali',
      description: '100 {{unit}} contiene:',
      items: {
        energy: 'Energia',
        fat: 'Grassi',
        saturates: 'di cui acidi grassi saturi',
        carbohydrates: 'Carboidrati',
        sugars: 'di cui zuccheri',
        protein: 'Proteine',
        salt: 'Sale',
      },
    },
  },
  units: {
    l: 'litro',
    kg: 'chilo',
    default: 'unità',
  },
};
